document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('usp-modal');
  if (!modal) return;

  // Move modal to <body> so it sits above all stacking contexts
  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  var overlay = modal.querySelector('.usp-modal__overlay');
  var closeBtn = modal.querySelector('.usp-modal__close');
  var bodies = modal.querySelectorAll('[data-usp-content]');

  function openModal(target) {
    bodies.forEach(function (body) {
      body.hidden = body.getAttribute('data-usp-content') !== target;
    });
    modal.classList.add('is-open');
    // if you DON'T want to lock scroll, leave these two lines commented:
    // document.body.classList.add('usp-lock');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    // document.body.classList.remove('usp-lock');
  }

  document.querySelectorAll('[data-usp-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-usp-trigger');
      openModal(target);
    });
  });

  if (overlay) overlay.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeModal();
  });
});
